import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import ResponseDetailsPersonal from "./ResponseDetailsPersonal";
import { Person } from "react-bootstrap-icons";
import ResponsePayerPersonal from "./ResponsePayerPersonal";
import CoverageInformationPersonal from "./CoverageInformationPersonal";
import IconButton from "components/common/IconButton";
import FloatingPrintButton from "./FloatingPrintIcon";
import FloatingExportButton from "./FloatingImageIcon";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import EligibilityResponsePatient from "./EligibilityResponsePatient";
import EligibilityPayerResponse from "./EligibilityPayerResponse";
import EligibilityCoveragePersonal from "./EligibilityCoveragePersonal";

const EligibilityReposnePersonalDetails = () => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const componentRef = useRef();
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  const location = useLocation();
  const hasPreauthorization = location.pathname.includes("preauthorization");
  const hasClaim = location.pathname.includes("claim");

  const { preauthorizationEligibility } = useSelector(
    (state) => state.preauthorization
  );
  const { eligibilityData } = useSelector((state) => state.claim);
  const { allPermissionType } = useSelector((state) => state.role);
  const eligibilitySetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Eligibility"
  );

  // 1. Extract Coverage resource safely
  const coverage =
    preauthorizationEligibility?.entry?.find(
      (e) => e.resource?.resourceType === "Coverage"
    )?.resource ||
    eligibilityData?.entry?.find((e) => e.resource?.resourceType === "Coverage")
      ?.resource ||
    eligibilityCheckData?.eligibility_response?.entry?.find(
      (e) => e.resource?.resourceType === "Coverage"
    )?.resource;

  return (
    <div
      className="d-flex flex-column p-2 border position-relative  rounded-3 flex-grow-1"
      ref={componentRef}
    >
      {/* Header Section */}
      <div className="p-2 d-flex align-items-center gap-3 border-bottom ">
        <div className="d-flex align-items-center gap-2">
          <Person />
          <span className="text-700 fw-bold fs-10">Provider Name</span>
        </div>
        <span className="fs-10">{selectedBranch?.branch_name}</span>
      </div>
      <div
        className="d-flex align-items-center gap-1"
        style={{ position: "absolute", top: 20, right: 20 }}
      >
        {Number(eligibilitySetting?.print) === 1 && <FloatingPrintButton />}
        {Number(eligibilitySetting?.export) === 1 && (
          <FloatingExportButton targetRef={componentRef} />
        )}
      </div>

      {/* Cards Row - Equal height columns */}
      <Row className="g-3 p-2 h-100">
        <Col xs={12} md={4} lg={3} className="h-100 d-flex">

          <div className="w-100 h-100">
            <EligibilityResponsePatient />
          </div>

        </Col>

        <Col xs={12} md={8} lg={5} className="h-100 d-flex">

          <div className="w-100 h-100 border rounded-3 p-3 overflow-auto">
            <EligibilityPayerResponse />
          </div>

        </Col>

        <Col xs={12} md={6} lg={4} className="h-100 d-flex">
          {
            eligibilityCheckData?.coverage_info && (
              <div className="w-100 h-100 border rounded-3 p-3 overflow-auto">
                <EligibilityCoveragePersonal />
              </div>

            )}
        </Col>
      </Row>
    </div>
  );
};

export default EligibilityReposnePersonalDetails;
